import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';

export const profileHistoryStateSlice = getCachedTableStateSlice<
    {profileId: number},
    undefined,
    undefined
>('roleProfileStateHistory', undefined, {currentPage: 1, pageSize: 10});

export const profileHistoryStateActions = profileHistoryStateSlice.actions;
export const profileHistoryStateSelector:
CachedTableStateSelector<{profileId: number}, undefined, undefined> =
    state => state.adminRights.profileHistory.state;
